var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" },
          [
            _c("c-tab", {
              attrs: {
                type: "tabcard",
                tabItems: _vm.tabItems,
                inlineLabel: true,
                align: "left",
              },
              on: {
                "update:tabItems": function ($event) {
                  _vm.tabItems = $event
                },
                "update:tab-items": function ($event) {
                  _vm.tabItems = $event
                },
                tabClick: _vm.tabClick,
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (tab) {
                    return [
                      _c(tab.component, {
                        tag: "component",
                        attrs: {
                          data: _vm.data,
                          imprTabInfo: _vm.imprTabInfo,
                          research: _vm.research,
                          dateItems: _vm.dateItems,
                          equipmentName: _vm.popupParam.equipmentName,
                          equipmentCd: _vm.popupParam.equipmentCd,
                          grid: _vm.grid,
                        },
                        on: {
                          "update:data": function ($event) {
                            _vm.data = $event
                          },
                          "update:imprTabInfo": function ($event) {
                            _vm.imprTabInfo = $event
                          },
                          "update:impr-tab-info": function ($event) {
                            _vm.imprTabInfo = $event
                          },
                          "update:research": function ($event) {
                            _vm.research = $event
                          },
                          "update:grid": function ($event) {
                            _vm.grid = $event
                          },
                          getDetail: _vm.getDetail,
                          setToday: _vm.setToday,
                          imprChange: _vm.imprChange,
                        },
                      }),
                    ]
                  },
                },
              ]),
              model: {
                value: _vm.tab,
                callback: function ($$v) {
                  _vm.tab = $$v
                },
                expression: "tab",
              },
            }),
          ],
          1
        ),
      ]),
      _c("c-dialog", { attrs: { param: _vm.popupOptions } }),
      _c("div", { staticClass: "popup-bottom-bar" }, [
        _c("div", { staticClass: "popup-bottom-bar-btngroup" }),
        _c(
          "div",
          { staticClass: "popup-bottom-bar-close" },
          [
            _c("q-btn", {
              attrs: { flat: "", color: "gray", icon: "arrow_back" },
              on: { click: _vm.closePopUps },
            }),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }